module.exports = __webpack_public_path__ + "img/GD.c45fa75a.svg";